import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { LabelsExcludedFromDashboard } from 'src/common/types/ConfigurationTypes';

import { DashboardDataQueryVariables } from '../DashboardData.generated';

import { buildDateVariables } from './dateVariableBuilder';
import { buildFilterVariables } from './filterVariableBuilder';

/**
 * Builds all variables for DashboardData GraphQL query
 * @param days - Number of days for the period
 * @param filters - Filter options from the UI
 * @param labelsExcludedFromDashboard - Labels to exclude from dashboard
 * @returns DashboardDataQueryVariables object with all query variables
 */
export const buildDashboardDataVariables = (
	days: number,
	filters?: IFilterOptions,
	labelsExcludedFromDashboard?: LabelsExcludedFromDashboard
): DashboardDataQueryVariables => {
	const dateVariables = buildDateVariables(days);
	const filterVariables = buildFilterVariables(filters, labelsExcludedFromDashboard);

	return {
		...dateVariables,
		...filterVariables
	} as DashboardDataQueryVariables;
};
